import { Box } from "@mui/material";
import React from "react";
import { dataMessage } from "../../interface/messages";
import MessageCover from "./message-cover";
import { ChartHeader } from "../../store/messageSlice";
import { SkeletonChatLoading } from "../ui-elements/skeleton-loading";

const MessageList = ({
  updateChartHeader,
  chats,
  selectChat,
}: {
  updateChartHeader: (data: ChartHeader) => void;
  chats: any[];
  selectChat: (e: number) => void;
}) => {
  
  return (
    <Box>
      {chats?.map((message, id) => (
        <MessageCover
          key={id}
          image={message?.photo_url}
          name={message?.name}
          chatId={message?.id}
          selectChat={selectChat}
          updateChartHeader={updateChartHeader}
          message={message?.last_message}
          time={message?.last_message_sent_at}
          chat_number={message?.unread_messages_count ?? 0}
        />
      ))}
   
    </Box>
  );
};

export default MessageList;
